import { IconChevronLeft, IconChevronRight } from '@frameio/vapor-icons';
import styles from './CarouselControls.module.css';
import TEXT from './generated/TEXT/CarouselControls';

TEXT.DEFINE({
  /** Accessibility label for previous suggestion button */
  previousSuggestion: 'Previous suggestion',
  /** Accessibility label for next suggestion button */
  nextSuggestion: 'Next suggestion',
});

type CarouselControlsProps = {
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
};

export const CarouselControls = ({
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
}: CarouselControlsProps) => {
  return (
    <div className={styles.navigationContainer}>
      <button
        aria-disabled={!canGoPrev}
        aria-label={TEXT.previousSuggestion}
        className={styles.buttonLeft}
        disabled={!canGoPrev}
        onClick={onPrev}
        type="button"
      >
        <IconChevronLeft size={16} />
      </button>
      <button
        aria-disabled={!canGoNext}
        aria-label={TEXT.nextSuggestion}
        className={styles.buttonRight}
        disabled={!canGoNext}
        onClick={onNext}
        type="button"
      >
        <IconChevronRight size={16} />
      </button>
    </div>
  );
};
